// Auto-generated section component extracted from Landing.jsx
import React from "react";


function DonationTypeIcon({ name, className = "h-6 w-6" }) {
  const common = { className, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.25", strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "cars":
      return (
        <svg {...common}><path d="M3 16v-3l2-5h14l2 5v3"/><path d="M5 16h14"/><circle cx="7" cy="16.5" r="1.5"/><circle cx="17" cy="16.5" r="1.5"/></svg>
      );
    case "clothes":
      return (
        <svg {...common}><path d="M9 4l3 2 3-2 3 3-2 2v11H8V9L6 7l3-3z"/></svg>
      );
    case "twoWheelers":
      return (
        <svg {...common}><circle cx="7" cy="17" r="3"/><circle cx="17" cy="17" r="3"/><path d="M7 17l4-7h4l2 3"/><path d="M11 10l-2-3"/></svg>
      );
    case "boats":
      return (
        <svg {...common}><path d="M3 17l9 4 9-4"/><path d="M4 17l3-7h10l3 7"/><path d="M9 10V4h6v6"/></svg>
      );
    case "houses":
      return (
        <svg {...common}><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/></svg>
      );
    case "lands":
      return (
        <svg {...common}><path d="M12 22s7-4.5 7-12a7 7 0 10-14 0c0 7.5 7 12 7 12z"/><circle cx="12" cy="10" r="2.2"/></svg>
      );
    case "rvs":
      return (
        <svg {...common}><path d="M3 7h14l4 5v5H3z"/><path d="M6 12h7"/><circle cx="7" cy="17" r="1.5"/><circle cx="17" cy="17" r="1.5"/></svg>
      );
    case "plants":
      return (
        <svg {...common}><path d="M12 21v-8"/><path d="M12 13c-3 0-6-2.5-6-6 3.5 0 6 2 6 6z"/><path d="M12 13c3 0 6-2.5 6-6-3.5 0-6 2-6 6z"/></svg>
      );
    case "jewelry":
      return (
        <svg {...common}><path d="M12 3l8 7-8 11L4 10l8-7z"/><path d="M4 10h16"/></svg>
      );
    case "constructionEquipment":
      return (
        <svg {...common}><path d="M4 20h16"/><path d="M7 20V8h6l4 4v8"/><path d="M13 8V4"/><path d="M13 4h5"/></svg>
      );
    case "kitchenAppliances":
      return (
        <svg {...common}><rect x="7" y="3" width="10" height="18" rx="2"/><path d="M10 7h4"/><path d="M10 12h4"/></svg>
      );
    case "commercialProperties":
      return (
        <svg {...common}><path d="M6 20V4h12v16"/><path d="M9 8h2"/><path d="M13 8h2"/><path d="M9 12h2"/><path d="M13 12h2"/><path d="M10 20v-4h4v4"/></svg>
      );
    case "officeEquipment":
      return (
        <svg {...common}><rect x="4" y="5" width="16" height="11" rx="2"/><path d="M8 21h8"/><path d="M12 16v5"/></svg>
      );
    case "airlineMileageCredit":
      return (
        <svg {...common}><path d="M2 16l10-4 10 4"/><path d="M12 12V3"/><path d="M12 3l3 3"/><path d="M12 3l-3 3"/></svg>
      );
    case "foodAndBeverages":
      return (
        <svg {...common}><path d="M6 3v18"/><path d="M6 7h4"/><path d="M10 3v18"/><path d="M14 3v18"/><path d="M18 3v8"/></svg>
      );
    case "electronicNews":
      return (
        <svg {...common}><path d="M4 6h16v12H4z"/><path d="M7 9h6"/><path d="M7 12h10"/><path d="M7 15h8"/></svg>
      );
    case "camera":
      return (
        <svg {...common}><path d="M5 7h3l2-2h4l2 2h3v12H5z"/><circle cx="12" cy="13" r="3"/></svg>
      );
    case "wrench":
      return (
        <svg {...common}><path d="M21 7a5 5 0 01-7 5l-7 7-3-3 7-7a5 5 0 015-7l-2 4 2 2 5-1z"/></svg>
      );
    case "memorial":
      return (
        <svg {...common}><path d="M12 21s-7-4.5-7-10a4 4 0 017-2 4 4 0 017 2c0 5.5-7 10-7 10z"/></svg>
      );
    default:
      return (
        <svg {...common}><circle cx="12" cy="12" r="9"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
      );
  }
}

function donationDesc(iconKey, tab) {
  // Short descriptions per category
  const k = String(iconKey || "");
  const t = String(tab || "");
  const map = {
    cars: "Cars, trucks, rentals, fleet support",
    clothes: "New/used apparel, uniforms, accessories",
    twoWheelers: "Bikes, scooters, e-bikes, gear",
    boats: "Boats, watercraft, marine equipment",
    houses: "Home donations, housing support, furnishings",
    lands: "Land parcels, lots, acreage donations",
    rvs: "RVs, campers, trailers, vans",
    plants: "Plants, landscaping, nursery supplies",
    jewelry: "Jewelry, valuables, collectibles",
    constructionEquipment: "Tools, heavy equipment, jobsite assets",
    kitchenAppliances: "Appliances, kitchen gear, smallwares",
    commercialProperties: "Commercial spaces, offices, buildings",
    officeEquipment: "Computers, printers, desks, office gear",
    airlineMileageCredit: "Miles, credits, travel vouchers",
    foodAndBeverages: "Food, beverages, catering support",
  };

  if (map[k]) return map[k];
  if (t === "media") return "Media support, coverage, outreach help";
  if (t === "services") return "In-kind professional services & labor";
  if (t === "memorial") return "Legacy support, memorial contributions";
  return "{donationDesc(it.iconKey, donationTab)}";
}


export default function DonationsSection({ api }) {
  const {
    donationItems = [],
    donationTab = "items",
    mediaDonation = [],
    memorialLegacyDonation = [],
    openDonationPublish = () => {},
    serviceDonation = [],
    setDonationTab = () => {},
    t = {
      donationSection: {
        heading: "Donations",
        sub: "",
        tabItems: "Items",
        tabMedia: "Media",
        tabServices: "Services",
        tabMemorial: "Memorial",
      },
    },
    // styles from Landing (fallbacks so section never crashes)
    pillBtn = "px-3 py-2 rounded-full text-xs sm:text-sm border transition-colors",
    pillActive = "border-emerald-400 bg-emerald-500/15 text-emerald-200",
    pillIdle = "border-slate-700 bg-[#0b1634]/60 text-slate-200 hover:border-emerald-400/60",
  } = api || {};
  return (
<section id="donations" className="space-y-6">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.donationSection.heading}
                </h2>
                <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
                  {t.donationSection.sub}
                </p>

                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/80 p-5 overflow-visible">
                  <div className="flex flex-wrap gap-2 mb-4">
                    {[
                      { id: "items", label: t.donationSection.tabItems },
                      { id: "media", label: t.donationSection.tabMedia },
                      { id: "services", label: t.donationSection.tabServices },
                      { id: "memorial", label: t.donationSection.tabMemorial },
                    ].map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => setDonationTab(tab.id)}
                        className={`${pillBtn} ${donationTab === tab.id ? pillActive : pillIdle
                          }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>

                  <div className="grid gap-4 grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 overflow-visible">
                    {(donationTab === "items"
                      ? donationItems
                      : donationTab === "media"
                        ? mediaDonation
                        : donationTab === "services"
                          ? serviceDonation
                          : memorialLegacyDonation
                    ).map((it) => (
                      <button
                        key={it.label}
                        onClick={() => openDonationPublish(it, donationTab)}
                        className="group rounded-3xl bg-[#061324]/60 p-4 border border-emerald-400/30 hover:border-emerald-400/50 hover:bg-[#061324]/75 transition"
                      >
                        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white shadow-inner">
                          <DonationTypeIcon name={it.iconKey} className="h-10 w-10 text-slate-800" />
                        </div>
                        <div className="mt-3 text-center text-sm font-semibold text-slate-100 leading-snug">
                          {it.label}
                        </div>
                        <div className="mt-1 text-center text-xs text-slate-300">
                          {donationDesc(it.iconKey, donationTab)}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </section>
  );
}
